import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import { formControlOverrides } from '@/shared/components/SDComponentsNewDesign/styled-components'
import useFiscalCode from './useFiscalCode'

const FiscalCode = () => {
  const { taxId, label, error, isEditable, status, onBlur, hidden } = useFiscalCode()

  if (hidden) {
    return null
  }

  return (
    <FormControl error={error} overrides={formControlOverrides}>
      <SDInput
        id='input-customer-tax-id-code'
        label={label}
        currentValue={taxId}
        disabled={isEditable === false}
        error={!!error}
        overrides={undefined}
        status={status}
        outerOnchange={undefined}
        onBlur={onBlur}
      />
    </FormControl>
  )
}

export default FiscalCode
